// src/pages/PaymentSuccess.jsx

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { verifyFlutterwavePayment, verifyPayment } from "../services/payments";
import API from "../services/api";

const PaymentSuccess = () => {
  const query = new URLSearchParams(useLocation().search);

  // ✅ Detect both providers
  const reference = query.get("reference"); // Paystack
  const transaction_id = query.get("transaction_id"); // Flutterwave

  const [loading, setLoading] = useState(true);
  const [paid, setPaid] = useState(false);
  const [productId, setProductId] = useState(null);

  useEffect(() => {
    const verify = async () => {
      try {
        let res;

        // 🔥 FLUTTERWAVE FLOW
        if (transaction_id) {
          console.log("Using Flutterwave verification");

          res = await verifyFlutterwavePayment(transaction_id);
          console.log("FLW VERIFY RESPONSE:", res);

          const status =
            res?.status ||
            res?.data?.status;

          if (status === "success") {
            setPaid(true);

            const pid =
              res?.product_id ||
              res?.data?.product_id;

            setProductId(pid);
          } else {
            setPaid(false);
          }

        // 🔥 PAYSTACK FLOW (fallback)
        } else if (reference) {
          console.log("Using Paystack verification");

          res = await verifyPayment(reference);
          console.log("PAYSTACK VERIFY RESPONSE:", res);

          const status =
            res?.data?.data?.status ||
            res?.data?.status ||
            res?.status;

          if (status === "success") {
            setPaid(true);

            const pid =
              res?.product_id ||
              res?.data?.product_id ||
              res?.data?.data?.metadata?.product_id;

            setProductId(pid);
          } else {
            setPaid(false);
          }

        } else {
          console.log("No payment reference found");
          setPaid(false);
        }

      } catch (err) {
        console.error("VERIFY ERROR:", err);
        setPaid(false);
      } finally {
        setLoading(false);
      }
    };

    // ✅ Only run if params exist
    if (transaction_id || reference) {
      verify();
    } else {
      setLoading(false);
      setPaid(false);
    }

  }, [reference, transaction_id]);

  // 🔐 SECURE DOWNLOAD
  const handleDownload = async () => {
    try {
      if (!productId) {
        alert("Product not found");
        return;
      }

      const response = await API.get(`/products/${productId}/download`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      const fileUrl = response.data.file_url;

      if (!fileUrl) {
        throw new Error("File URL not found");
      }

      window.open(fileUrl, "_blank");

    } catch (err) {
      console.error("DOWNLOAD ERROR:", err);
      alert("Download failed");
    }
  };

  if (loading) {
    return <h1>Verifying Payment... ⏳</h1>;
  }

  return (
    <div style={{ padding: 20 }}>
      {paid ? (
        <>
          <h1>🎉 Payment Successful!</h1>
          <p>You can now download your product.</p>

          <button
            onClick={handleDownload}
            style={{
              padding: "10px 20px",
              background: "green",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
              marginTop: "10px",
            }}
          >
            Download Product
          </button>
        </>
      ) : (
        <>
          <h1>❌ Payment Failed</h1>
          <p>Please try again.</p>
        </>
      )}
    </div>
  );
};

export default PaymentSuccess;